module.exports = [{"address":"United Kingdom","lat_g":49.829211,"lat_l":59.721894,"lng_l":2.673823,"lng_g":-10.921827}]